
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import EmphasisedLink from './emphasised-link'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "emphasisedlink"
    }}>{`EmphasisedLink`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Navigation`}</p>
    <hr />
    <h2 {...{
      "id": "emphasised-link"
    }}>{`Emphasised link`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For links of greatest importance. Limit the number of emphasised links on screen to avoid disminishing the link’s prominence. Useful for linking to content and external actions.`}</p>
    <Playground __position={1} __code={'<EmphasisedLink text=\"Emphasised link\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      EmphasisedLink
    }} mdxType="Playground">
  <EmphasisedLink text='Emphasised link' href='/' mdxType="EmphasisedLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "emphasised-link-inverse"
    }}>{`Emphasised link (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For links of greatest importance. Limit the number of emphasised links on screen to avoid disminishing the link’s prominence. Useful for linking to content and external actions.`}</p>
    <Playground __position={3} __code={'<EmphasisedLink inverse text=\"Emphasised link\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      EmphasisedLink
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <EmphasisedLink inverse text='Emphasised link' href='/' mdxType="EmphasisedLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "emphasised-link-secondary"
    }}>{`Emphasised link (secondary)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For links of greatest importance. Limit the number of emphasised links on screen to avoid disminishing the link’s prominence. Useful for linking to content and external actions.`}</p>
    <Playground __position={5} __code={'<EmphasisedLink variant=\"secondary\" text=\"Emphasised link\" href=\"/\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      EmphasisedLink
    }} mdxType="Playground">
  <EmphasisedLink variant='secondary' text='Emphasised link' href='/' mdxType="EmphasisedLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={EmphasisedLink} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;